import { Navigate } from 'react-router-dom';
import { useCandidateAuth } from '@/hooks/useCandidateAuth';
import LoadingSpinner from '@/components/ui/LoadingSpinner';

/**
 * Smart redirect component that routes users based on authentication state
 * - Authenticated applicants -> Application form
 * - Unauthenticated users -> Magic link login
 */
export function AuthRedirect() {
  const { isAuthenticated, isLoading } = useCandidateAuth();

  // Show loading while checking authentication state
  if (isLoading) {
    return <LoadingSpinner />;
  }

  // Redirect based on authentication status
  if (isAuthenticated) {
    return <Navigate to="/application/step/1" replace />;
  }

  return <Navigate to="/auth/magic-link" replace />;
}
